// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"159":"f5509746453337578120","339":"ca014f3bb2f19b3cfe1a"}[chunkId] + ".js";
};